// ============================================================================
// Persistence — localStorage helpers for session and file viewer state
// ============================================================================

// ---- recent directories ----
export function loadRecentDirs() {
  try { return JSON.parse(localStorage.getItem("devin-recent-dirs") || "[]"); }
  catch { return []; }
}

export function saveRecentDir(dir) {
  const dirs = loadRecentDirs().filter((d) => d !== dir);
  dirs.unshift(dir);
  localStorage.setItem("devin-recent-dirs", JSON.stringify(dirs.slice(0, 10)));
}

// ---- session persistence (resume on reload) ----
export function saveActiveSession(cwd, sessionId) {
  localStorage.setItem("devin-active-session", JSON.stringify({ cwd, sessionId, ts: Date.now() }));
}

export function loadActiveSession() {
  try { return JSON.parse(localStorage.getItem("devin-active-session") || "null"); }
  catch { return null; }
}

export function clearActiveSession() {
  localStorage.removeItem("devin-active-session");
}

// ---- file viewer state persistence (per workspace) ----
export const FV_STATE_KEY = "devin-fv-state";

export function loadFvStateMap() {
  try { return JSON.parse(localStorage.getItem(FV_STATE_KEY) || "{}"); }
  catch { return {}; }
}

export function loadFvState(cwd) {
  if (!cwd) return null;
  return loadFvStateMap()[cwd] || null;
}

export function clearFvStateMap(cwd) {
  const map = loadFvStateMap();
  if (map[cwd]) { delete map[cwd]; localStorage.setItem(FV_STATE_KEY, JSON.stringify(map)); }
}

// ---- pinned docs & snippets ----
// Pins are a conversation's working set: per-session arrays plus a
// "global" tier that renders in every session, plus a "pending" bucket for
// pins made before the server assigns a sessionId (migrated on first id).
//   { global: Pin[], pending: Pin[], sessions: { [sessionId]: Pin[] } }
export const PINS_KEY = "devin-pins";

export function loadPinsMap() {
  try {
    const raw = JSON.parse(localStorage.getItem(PINS_KEY) || "{}");
    if (!raw || typeof raw !== "object") return { global: [], pending: [], sessions: {} };
    return {
      global: Array.isArray(raw.global) ? raw.global : [],
      pending: Array.isArray(raw.pending) ? raw.pending : [],
      sessions: raw.sessions && typeof raw.sessions === "object" ? raw.sessions : {},
    };
  }
  catch { return { global: [], pending: [], sessions: {} }; }
}

export function savePinsMap(map) {
  try { localStorage.setItem(PINS_KEY, JSON.stringify(map)); }
  catch { /* quota — ignore */ }
}
